import { Component, OnInit } from '@angular/core';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { CommandEnum } from '@app/forms/subscription/definition/interface/enum';
import { catchError, finalize, take, Observable, of } from 'rxjs';

@Component({
    selector: 'initialization-contract-form',
    templateUrl: './initialization-contract-form.component.html',
    styleUrls: ['./initialization-contract-form.component.scss'],
    standalone: false
})
export class InitializationContractFormComponent implements OnInit {
  step;
  loading = false;
  obser$: Observable<any>;
  constructor(private subscriptionFacade: SubscriptionFacadeService) {}

  ngOnInit() {
    this.step = this.subscriptionFacade.getStep();
    this.setCommands();
  }
  setCommands() {
    const pledge = this.subscriptionFacade.getPledge();
    this.loading = true;
    this.obser$ = this.subscriptionFacade
      .putPledge({
        ...pledge,
        commands: [CommandEnum.RECALCULATE_RISK_PROFIL],
      })
      .pipe(
        take(1),
        catchError(err => {
          this.loading = false;
          return of(err);
        }),
        finalize(() => {
          this.loading = false;
        }),
      );
  }

  next() {
    this.subscriptionFacade.nextStep();
  }
  prev() {
    this.subscriptionFacade.previousStep();
  }
}
